import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { Container } from "@mui/system";
import {
  Typography,
  Paper,
  Box,
  TextField,
  Grid,
  Button,
  CircularProgress,
  Alert,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import React from "react";
import Page from "../components/Page";

//Hooks
import { useFirestore } from "../hooks/useFirestore";
import { useDocument } from "../hooks/useDocument";
import { useCollection } from "../hooks/useCollection";

function DeliveryForm() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { document } = useDocument("Delivery");
  const { documents } = useCollection("Delivery");

  const { addDocument, message, isError, isPending, updateDocument } =
    useFirestore("Delivery");
  const [name, setName] = useState("");
  const [date, setDate] = useState("");
  const [orderNo, setOrderNo] = useState("");
  const [rep, setRep] = useState("");
  const [sign, setSign] = useState("");
  const [position, setPosition] = useState("");
  const [items, setItems] = useState([
    {
      description: "",
      quantity: "",
      part: "",
    },
  ]);

  useEffect(() => {
    const detail = async () => {
      try {
        const docSnap = await document(id);
        // console.log(docSnap.data())
        setName(docSnap.data().name);
        setItems(docSnap.data().items);
        setDate(docSnap.data().date);
        setOrderNo(docSnap.data().orderNo);
        setSign(docSnap.data().sign);
        setPosition(docSnap.data().position);
        setRep(docSnap.data().rep);
      } catch (error) {
        console.log(error);
      }
    };
    if ((id !== undefined || id !== "") && id !== ":id") {
      detail();
    }

    // eslint-disable-next-line
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const number = documents.length + 1;
    try {
      if ((id !== undefined || id !== "") && id !== ":id") {
        await updateDocument(id, {
          name,
          items,
          date,
          orderNo,
          rep,
          sign,
          position,
        });
      } else {
        await addDocument({
          name,
          items,
          date,
          orderNo,
          rep,
          number,
          sign,
          position,
        });
      }
    } catch (error) {
      // console.log('msg', error.message)
    }
  };

  const handleFormChange = (i, e) => {
    let data = [...items];
    data[i][e.target.name] = e.target.value;
    setItems(data);
  };

  const addField = () => {
    let newField = {
      description: "",
      quantity: "",
      part: "",
    };
    setItems([...items, newField]);
  };

  const removeField = (i) => {
    let data = [...items];
    data.splice(i, 1);
    setItems(data);
  };

  useEffect(() => {
    if (message) {
      setTimeout(() => {
        navigate("/dashboard/delivery");
      }, 5000);
    }
  });

  return (
    <Page title="Add Company">
      <Container maxWidth="xl">
        <Box component="form" onSubmit={handleSubmit}>
          <Paper elevation={6} sx={{ p: 4 }}>
            <Typography variant="h4" sx={{ m: 1, textAlign: "center" }}>
              Add Delivery
            </Typography>
            <Box sx={{ mb: 4 }}>
              {message && (
                <Alert variant="filled" severity="success">
                  {message}
                </Alert>
              )}
              {isError && (
                <Alert variant="filled" severity="error">
                  {isError}
                </Alert>
              )}
            </Box>
            <Grid
              container
              sx={{
                mb: 4,
              }}
              spacing={2}
            >
              <Grid item xs={12} md={4} sm={4}>
                <TextField
                  fullWidth
                  placeholder="Enter Customer Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={4} sm={4}>
                <TextField
                  fullWidth
                  placeholder="Select Date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  type="date"
                />
              </Grid>
              <Grid item xs={12} md={4} sm={4}>
                <TextField
                  fullWidth
                  placeholder="Enter Order Number"
                  value={orderNo}
                  onChange={(e) => setOrderNo(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={4} sm={4}>
                <TextField
                  fullWidth
                  placeholder="Enter Rep"
                  value={rep}
                  onChange={(e) => setRep(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <TextField
                  placeholder="Enter Sign By: Name"
                  value={sign}
                  onChange={(e) => setSign(e.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <TextField
                  placeholder="Enter Sign By: Position"
                  value={position}
                  onChange={(e) => setPosition(e.target.value)}
                  fullWidth
                />
              </Grid>
            </Grid>

            {items.map((input, i) => {
              return (
                <Grid
                  container
                  spacing={2}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2,
                  }}
                  key={i}
                >
                  <Grid item xs={12} md={4} sm={6}>
                    <TextField
                      fullWidth
                      placeholder="Enter Description"
                      name="description"
                      value={input.description}
                      onChange={(e) => handleFormChange(i, e)}
                    />
                  </Grid>
                  <Grid item xs md={4} sm={4}>
                    <TextField
                      fullWidth
                      placeholder="Enter Part No"
                      name="part"
                      value={input.part}
                      onChange={(e) => handleFormChange(i, e)}
                    />
                  </Grid>
                  <Grid item xs={2} md={3} sm={3}>
                    <TextField
                      fullWidth
                      placeholder="Enter Quantity"
                      name="quantity"
                      value={input.quantity}
                      onChange={(e) => handleFormChange(i, e)}
                    />
                  </Grid>
                  <Grid item xs={2} md={1} sm={1}>
                    <IconButton color="error" onClick={() => removeField(i)}>
                      <DeleteIcon />
                    </IconButton>{" "}
                  </Grid>
                </Grid>
              );
            })}
            <Grid
              container
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mt: 2,
              }}
            >
              <Grid item xs={12} sm={6} md={6}>
                <Button
                  size="medium"
                  variant="contained"
                  onClick={addField}
                  //   color="success"
                  sx={{
                    backgroundColor: "#ee82ee",
                    "&:hover": {
                      backgroundColor: "#ee82ee",
                      boxShadow: "none",
                    },
                  }}
                >
                  Add Branch
                </Button>
              </Grid>
            </Grid>
            <Grid
              container
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mt: 4,
              }}
            >
              <Grid item xs={12} md={7} sm={7} sx={{ mb: 5 }}>
                {!isPending && (
                  <Button
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Submit
                  </Button>
                )}
                {isPending && (
                  <Button
                    fullWidth
                    size="large"
                    type="submit"
                    variant="outlined"
                  >
                    <CircularProgress />
                  </Button>
                )}
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </Container>
    </Page>
  );
}

export default DeliveryForm;
